import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const color = this.inputTarget.value
    if (this.isValidHex(color)) {
      this.previewTarget.style.backgroundColor = color
      this.inputTarget.classList.remove('is-invalid')
      this.inputTarget.classList.add('is-valid')
    } else {
      this.inputTarget.classList.remove('is-valid')
      this.inputTarget.classList.add('is-invalid')
    }
  }

  selectSwatch(event) {
    const color = event.currentTarget.getAttribute('data-color')
    this.inputTarget.value = color
    this.updatePreview()

    // Trigger change event so form validation works
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  isValidHex(hex) {
    return /^#[A-Fa-f0-9]{6}$/.test(hex)
  }
}